import RankTypes from './types';
import { Reducer } from 'redux';
import { OnnaRankState, OnnaRankDispatchAction } from './state';

const initialState : OnnaRankState = {
    rank: ''
}

const RankReducer : Reducer<OnnaRankState, OnnaRankDispatchAction> = 
    (state = initialState, action) => {
        switch(action.type) {
            case RankTypes.FETCH_START:
                return state
            case RankTypes.FETCH_SUCCESS:
                return action.payload
            default:
                return state
        }
    }

export default RankReducer;